import { toRefs, ref, computed } from 'vue';
import unescape from 'lodash/unescape';
import ProfileBtn from '../btn/component-lib.esm3.js';
import BtnExpand from '../shared/component-lib.esm.js';
import ChevronIcon from '../../icons/arrows/component-lib.esm2.js';
import { useEmbedOptions } from '../../compositions/component-lib.esm.js';
import { appendUTMParams } from '../../utils/component-lib.esm4.js';
import { truncate } from '../../utils/component-lib.esm7.js';

//
var script = {
  components: {
    ProfileBtn,
    ProfileEmbedContainer: () => import( /* webpackPrefetch: true */'../embed/component-lib.esm3.js').then(d => d.default),
    BtnExpand,
    ChevronIcon
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    link: {
      type: Object,
      default: null
    },
    embedType: String,
    showImages: Boolean,
    enableUtmParameters: Boolean,
    utmMedium: String,
    utmSource: String,
    highlight: String,
    btnProps: Object
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      item,
      showImages,
      embedType
    } = toRefs(props);
    const expand = ref(false);
    const isOpen = ref(false);
    const label = computed(() => {
      return unescape(item.value.title);
    });
    const baseLinkUrl = computed(() => {
      return item.value.url;
    });
    const [isEmbedLink, embedOptions, embedId] = useEmbedOptions({
      embedType,
      url: baseLinkUrl
    });
    const originalUrl = computed(() => {
      return item.value.url;
    });
    const linkUrl = computed(() => {
      if (props.enableUtmParameters) {
        return appendUTMParams(originalUrl.value, props.utmMedium, props.utmSource, label.value);
      } else return originalUrl.value;
    });
    const hasImage = computed(() => {
      return item.value.images || item.value.image;
    });
    const imageUrl = computed(() => {
      if (!showImages.value || !hasImage.value) return null;
      return item.value.image || item.value.images.min;
    });
    const labelFormatted = computed(() => {
      return truncate(label.value, 80);
    });
    function handleClick() {
      const clickData = {
        href: originalUrl.value,
        text: labelFormatted.value
      };
      if (isEmbedLink.value) {
        if (!isOpen.value) emit('click', clickData);
        isOpen.value = !isOpen.value;
      } else {
        emit('click', clickData);
      }
    }
    return {
      expand,
      isOpen,
      isEmbedLink,
      embedOptions,
      embedId,
      linkUrl,
      imageUrl,
      label,
      labelFormatted,
      handleClick
    };
  }
};
export { script as default };